import { X } from 'lucide-react';
import { useErrorStore } from '@/store/useErrorStore';

const LEAD = 'Something went wrong.';

/** "Something went wrong. <message>" — the lead is added unless the message already says it. */
export function bannerText(message: string): string {
  const m = message.trim();
  if (!m) return LEAD;
  return /^something went wrong/i.test(m) ? m : `${LEAD} ${m}`;
}

/**
 * The app's error toast: green, white text, and always the request's
 * correlation id ("Id: …") so a screenshot is enough to find every log line
 * for it (SPA, BFF, sreg-api, agent).
 */
export function ErrorBanner() {
  const error = useErrorStore((s) => s.error);
  const dismiss = useErrorStore((s) => s.dismiss);
  if (!error) return null;
  return (
    <div
      role="alert"
      className="fixed left-1/2 top-4 z-50 w-[min(560px,92vw)] -translate-x-1/2 rounded-xl bg-sage px-4 py-3 text-white shadow-xl"
    >
      <div className="flex items-start gap-3">
        <p className="flex-1 text-sm font-medium">{bannerText(error.message)}</p>
        <button aria-label="Dismiss" onClick={dismiss} className="text-white/80 hover:text-white">
          <X size={16} />
        </button>
      </div>
      {error.correlationId && (
        <p className="mt-1 select-all font-mono text-xs text-white/85">Id: {error.correlationId}</p>
      )}
    </div>
  );
}
